<template>
    <div>
        <!-- 注册弹框 start -->
        <el-dialog title="24小时客服热线：400-6565958" :close-on-click-modal=false :close-on-press-escape=false :visible.sync="dialogRegister" width="700px" style="padding: 10px 0;">
            <el-row v-loading="registarLoading">
                <el-col :span="10">
                    <div class="login-code textCenter" style="height: 325px; padding-top: 80px;">
                        <img src="../assets/images/login_code.png" alt="" srcset="">
                        <p>扫一扫下载唐宋钢铁APP<br>钢铁行情一手掌握</p>
                    </div>
                </el-col>
                <el-col :span="14">
                    <div class="login-form">
                        <el-form :model="registerForm" :rules="registerRules" ref="registerForm">
                            <div class="textCenter" style="margin-top: -10px; margin-bottom: 10px;">
                                <el-radio v-model="registerForm.target" label="e" @change="isCompany = true">企业用户</el-radio>
                                <el-radio v-model="registerForm.target" label="p" @change="isCompany = false">个人用户</el-radio>
                            </div>
                            <el-form-item prop="telephone">
                                <el-input clearable v-model="registerForm.telephone" auto-complete="off" placeholder="请输入手机号" style="margin-bottom: 10px;" class="w100" @blur="checkUser()"></el-input>
                                <i class="el-icon-error fontRed font20" v-show="isShowCan == 2 && registerForm.telephone != ''" style="position: absolute; top: 10px;"></i>
                                <i class="el-icon-success fontGreen font20" v-show="isShowCan == 3 && registerForm.telephone != ''" style="position: absolute; top: 10px;"></i>
                            </el-form-item>
                            <el-form-item prop="enterpriseName" v-show="isCompany">
                                <el-input clearable v-model="registerForm.enterpriseName" auto-complete="off" placeholder="请输入公司名称" style="margin-bottom: 10px;" class="w100"></el-input>
                            </el-form-item>
                            <el-form-item prop="password">
                                <el-input clearable type="password" v-model="registerForm.password" auto-complete="off" placeholder="请设置密码" style="margin-bottom: 10px;" class="w100"></el-input>
                            </el-form-item>
                            <el-form-item prop="code">
                                <el-input clearable v-model="registerForm.code" auto-complete="off" placeholder="请输入验证码" class="w100">
                                    <template slot="append" class="pointer">
                                        <span class="pointer" v-show="sendCodeTime == 0" @click="sendCode">发送验证码</span>
                                        <span v-show="sendCodeTime != 0">({{ sendCodeTime }})秒后重新发送</span>
                                    </template>
                                </el-input>
                            </el-form-item>
                        </el-form>
                        <div slot="footer" class="dialog-footer" style="margin-top: 15px;">
                            <el-button class="bgRed w100 fontWhite" @click="register('registerForm')" size="medium">注 册</el-button>
                        </div>
                    </div>
                </el-col>
            </el-row>
        </el-dialog>
        <!-- 注册弹框 end -->

        <!-- 注册完成后 start -->
        <!-- <el-dialog title="24小时客服热线：400-6565958" :close-on-click-modal=false :close-on-press-escape=false :visible.sync="dialogImprove" width="700px" style="padding: 10px 0;" class="login-improve" :show-close=false>
            <el-row>
                <el-col :span="24">
                    <div class="font16 textLeft">
                        <i class="el-icon-success fontGreen" style="font-size: 24px; padding-right: 10px"></i>
                        <span class="fontGreen">您已成功注册！</span>
                        <span>完善以下信息有助于您获得更好的信息服务：</span>
                        <el-button size="mini" style="float: right;" @click="submitImprove(1)">放弃完善</el-button>
                    </div>
                </el-col>
            </el-row>
            <el-row :gutter="20" class="mw-modular-box">
                <el-col :span="4">
                    <span>您的企业类型</span>
                </el-col>
                <el-col :span="20">
                    <div class="type-box radius textLeft">
                        <el-checkbox-group v-model="enterpriseType" @change="checkEnterprise">
                            <el-checkbox :label="item.typeId" v-for="(item, index) in enterpriseType_data" :key="index" style="margin: 15px 15px 0 0;">{{ item.typeName }}</el-checkbox>
                        </el-checkbox-group>
                    </div>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="4">
                    <span>您的关注品种</span>
                </el-col>
                <el-col :span="20">
                    <div class="type-box radius textLeft">
                        <el-checkbox-group v-model="focusProduct" @change="checkProduct">
                            <el-checkbox :label="item.navigationId" v-for="(item, index) in focusProduct_data" :key="index" style="margin: 15px 15px 0 0;">{{ item.navigationName }}</el-checkbox>
                        </el-checkbox-group>
                    </div>
                </el-col>
            </el-row>
            <div slot="footer" class="dialog-footer">
                <el-button class="bgRed w100 fontWhite" @click="submitImprove(2)" size="medium">提 交</el-button>
            </div>
        </el-dialog> -->
        <!-- 注册完成后 end -->
    </div>
</template>

<script>
import $ from 'jquery'
import '../assets/js/gVerify'
import { mw_validate, baseUrl } from '../assets/js/common'
export default {
    name: 'Register',
    components: {},
    props: {
    },
    data () {
        return {
            userId: '',
            dialogRegister: false, // 注册弹出层,
            dialogImprove: false, // 注册完成后完善信息弹出层
            registarLoading: false,
            isCompany: true, // 默认企业注册
            sendCodeTime: 0, // 计时器
            code: '', // 发送的验证码
            enterpriseType_data: [],
            enterpriseType: [], // 关注的企业类型
            focusProduct_data: [],
            focusProduct: [], // 关注的品种
            registerForm: { // 注册的所有信息
                type: '2', // crm 通过手机号注册传2
                target: 'e', // 用户类型
                telephone: '', // 手机号
                enterpriseName: '', // 企业名称
                password: '', // 密码
                code: '', // 验证码
                focusProduct: [], //关注品种
                enterpriseType: [] // 企业类型
            },
            registerRules: {
                telephone: [
                    { required: true, message: '请输入手机号', trigger: 'blur' }
                ],
                password: [
                    { required: true, message: '请输入密码', trigger: 'blur' },
                    { min: 6, max: 16, message: '请设置6-16位密码', trigger: 'blur' }
                ],
                code: [
                    { required: true, message: '请输入验证码', trigger: 'blur' }
                ]
            },
            isShowCan: 1, // 用户是否可以注册
        }
    },
    mounted () {
        // 初始化内容
    },
    methods: {
        init () {
            this.dialogRegister = true;
        },
        checkUser () {
            const self = this;
            self.$get(`${baseUrl.business}/api/user/checkUser/${self.registerForm.telephone}`, {}).then(res => {
                if (res.status == 200) {
                    self.isShowCan = 3;
                } else {
                    self.isShowCan = 2;
                    self.$message.error(res.msg);
                }
            })
        },
        /* 注册 */
        register (formName) {
            const self = this;
            self.$refs[formName].validate((valid) => {
                if (valid) {
                    // 判断手机号是否正确
                    if (!mw_validate.phone(self.registerForm.telephone)) {
                        self.$message({
                            message: '请输入正确的手机号',
                            type: 'warning'
                        });
                        return;
                    } else if (self.isCompany && (!self.registerForm.enterpriseName || !mw_validate.company(self.registerForm.enterpriseName))) {
                        self.$message({
                            message: '请输入企业名称',
                            type: 'warning'
                        });
                        return;
                    } else { // 验证成功后
                        // 进行验证码验证
                        self.registarLoading = true;
                        self.checkCode()
                    }
                    
                } else {
                    return false;
                }
            });
        },

        // 发送验证码
        sendCode () {
            const self = this;
            self.sendCodeTime = 60;
            let interval = setInterval(() => {
                if (self.sendCodeTime == 0) {
                    clearInterval(interval);
                } else {
                    if (self.sendCodeTime == 60) {
                        // 发送手机验证码
                        self.$get(`${baseUrl.sso}/api/sendCode?telephone=${self.registerForm.telephone}`, {}).then(res => {
                            if (res.code == 200) {
                                self.code = res.data;
                                this.$message('验证码已发送');
                            } else {
                                self.codeErrMsg(res.msg);
                                self.sendCodeTime = 0;
                            }
                        }).catch(err => {
                            self.registarLoading = false;
                            self.$message.error('验证码发送失败');
                            self.sendCodeTime = 0;
                        })
                    }
                    self.sendCodeTime--;
                }
            }, 1000)
        },

        // 验证验证码
        checkCode () {
            let self = this;
            // // step1. 验证 验证码是否有效
            self.$get(`${baseUrl.sso}/api/checkCodeIsValid?telephone=${self.registerForm.telephone}`, {}).then(res => {
                if (res.code == 200) {
                    self.$postByX(`${baseUrl.sso}/api/checkCodeIsTrue?telephone=${self.registerForm.telephone}&code=${self.registerForm.code}`, {}).then(res_2 => {
                        if (res_2.code == 200) {
                            // 验证成功，提交数据
                            self.registerInfo();
                        } else {
                            self.codeErrMsg(res_2.msg);
                        }
                    })
                } else {
                    self.codeErrMsg(res.msg);
                }
            }) 
        },

        // 验证码错误提示
        codeErrMsg (message) {
            let self = this;
            self.registarLoading = false;
            self.$message.error(message);
        },

        // 提交注册信息
        registerInfo () {

            let self = this;
            // /${self.registerForm.type}
            self.$post(`${baseUrl.business}/api/user/register`, {phone: self.registerForm.telephone, password: self.registerForm.password}).then(res => { // 保存后获取用户id
                if (res.status == 200) {
                    self.$cookies.set('token_cyw', res.data.token, '0');
                    self.userId = res.data.userInfo.id;
                    // 保存用户类型
                    self.$post(`${baseUrl.cyw}/userTarget/addUserTarget`, {crmUserId: res.data.userInfo.id, target: self.registerForm.target}).then(res_2 => {
                        if (res_2.code == '0') {
                            self.submitImprove(2);
                        } else {
                            self.$message.error(res_2.message)
                            self.registarLoading = false;
                        }
                    }).catch(err => {
                        self.$message.error('保存失败')
                    })
                } else {
                    self.$message.error(res.msg)
                    self.registarLoading = false;
                }
            }).catch(err => {
                self.$message.error('保存失败')
            })
        },

        /* 完善信息 填或者不填 都调这个借口*/
        submitImprove (close) {
            const self = this;
            if (close == 1) { // 取消
                self.$confirm('确认放弃完善信息?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let newObj = {
                        source: '产业网',
                        telephone: self.registerForm.telephone,
                        pwd: self.registerForm.password,
                        enterpriseName: self.registerForm.enterpriseName,
                        focusProduct: '',
                        enterpriseType: ''
                    }
                    self.postImprove(newObj)
                });
            } else {
                let newObj = {
                    id: self.userId,
                    username: self.registerForm.telephone,
                    phone: self.registerForm.telephone,
                    password: self.registerForm.password,
                    enterpriseName: self.registerForm.enterpriseName
                }
                self.postImprove(newObj)
            }
        },
        // 保存用户企业名称，用修改用户的接口postImprove
        postImprove (obj) {
            if (obj.enterpriseName) {
                const self = this;
                self.$put(`${baseUrl.business}/api/user/update`, obj).then(res => {
                    if (res.status == 200) {
                        const token_cyw = self.$cookies.get('token_cyw');
                        self.$message('注册成功')
                        self.registarLoading = false;
                        setTimeout(() => {
                            self.$router.go(0);
                        }, 500)
                    } else {
                        self.$message.error(res.message)
                    }
                }).catch(err => {
                    self.$message.error('注册失败')
                })
            }
        },
        // 完善信息接口 不调这个
        // postImprove(obj) {
        //     const self = this;
        //     self.$post(`${baseUrl.crm}/business/cyw/openapi/addCYWUser.json`, obj).then(res => {
        //         if (res.code == 200) {
        //             const token_cyw = self.$cookies.get('token_cyw');
        //             self.$message('注册成功')
        //             setTimeout(() => {
        //                 self.$router.go(0);
        //             }, 500)
        //         } else {
        //             self.$message.error(res.message)
        //         }
        //     }).catch(err => {
        //         self.$message.error('注册失败')
        //     })
        // },

        // 获取完善信息 - 企业类型
        // getEnterpriseType () { 
        //     const self = this;
        //     self.$get(`${baseUrl.crm}/business/cyw/openapi/getEnterpriseType.json`, {}).then(res => {
        //         if (res.code == 200) {
        //             self.enterpriseType_data = res.data;
        //         } else {
        //             self.$message.error(res.msg);
        //         }
        //     }).catch(err => {
        //         self.$message.error('未获取到企业类型')
        //     })
        // },
        // 获取完善信息 - 企业类型
        // getFocusProduct () {
        //     const self = this;
        //     self.$get(`${baseUrl.cyw}/navigation/selectNa?level=2`, {}).then(res => {
        //         if (res.code == 0) {
        //             self.focusProduct_data = res.data;
        //         } else {
        //             self.$message.error(res.message);
        //         }
        //     }).catch(err => {
        //         self.$message.error('未获取到产品类型')
        //     })
        // },

        // 选择关注的产品
        // checkProduct (ids) {
        //     this.registerForm.focusProduct = [].slice.call(ids);
        // },
        // 选择企业类型
        // checkEnterprise (ids) {
        //     this.registerForm.enterpriseType = [].slice.call(ids);
        // },

    }
}
</script>

<style scoped>
    .login-code { border-right: 1px solid #f6f6f6; }
    .login-code img { width: 180px; }
    .login-code p { line-height: 26px; }
    .login-form, .top .login-code { padding: 40px; }
    .login-form .check-code { padding: 15px 0; }
    .login-form .check-code .code-before { border: 1px solid #f6f6f6; height: 30px; line-height: 30px; width: 65px; position: relative; }
    .login-form .check-code .code-after { border: 1px solid #ccc; border-radius: 5px; width: 65px; height: 30px; margin-left: 5px; margin-right: 5px;}
    .dialog-footer > div { height: 30px; line-height: 30px; }
    .login-improve .type-box { border: 1px solid #eee; padding: 0 15px 15px 15px; margin-top: 10px; }
</style>